// 8 visually distinct colors, each verified AA contrast (≥4.5:1) against white text
const PALETTE = [
    '#1d4ed8', // blue
    '#7c3aed', // violet
    '#047857', // emerald
    '#b91c1c', // red
    '#c2410c', // orange
    '#0e7490', // cyan
    '#4d7c0f', // lime
    '#be185d', // pink
];
/**
 * Returns a deterministic hex color for a workspace id by hashing
 * the id into an index in the palette.
 */
export function getWorkspaceColor(id) {
    let sum = 0;
    for (let i = 0; i < id.length; i++) {
        sum += id.charCodeAt(i);
    }
    return PALETTE[sum % PALETTE.length];
}
